export const phoneText = '';